import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

interface UseDeleteEstablishmentRequiredDocumentProps {
  id: string
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: ErrorResponse) => void
}

export const useDeleteEstablishmentRequiredDocument = ({
  id,
  onSuccess,
  onError,
}: UseDeleteEstablishmentRequiredDocumentProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deleteEstablishmentRequiredDocument'],
    mutationFn: () => privateAxios.delete(`/maintenance/establishment_required_documents/${id}`),
    onSuccess,
    onError,
  })
}
